import React from "react";
import { useLocation } from "react-router-dom";

const Success = () => {
  const { state } = useLocation();

  return (
    <div className="h-screen flex flex-col justify-center items-center gap-2 p-5">
      <img
        src="/assets/images/success.gif"
        alt="Success"
        className="md:w-[500px]"
      />

      <p className="text-green-500 text-2xl font-semibold">Thank You!</p>
      
      <p className="text-secondaryLight1 text-lg text-center">
        {state?.message || ""}
      </p>
    </div>
  );
};

export default Success;
